import { gql } from '@apollo/client';

export const RESET_USER_QUESTIONS_SEEN = gql`
  mutation ResetUserQuestionsSeen($tag: String!) {
    resetUserQuestionsSeen(tag: $tag)
  }
`;
